import React, { useState } from 'react'
import { toHtml } from '~/utils'
import { MyModal } from '~/components/ui/MyModal'

export const ReadMore: React.FC<{
  text: string
  title: string
  limit: number
  style?: React.CSSProperties
  className?: string
}> = ({ text, title, limit, style, className }) => {
  const [visible, setVisible] = useState(false)

  return (
    <>
      <div className={className} style={style}>
        {text.length >= limit ? (
          <>
            {text.substring(0, limit) + '...'}{' '}
            <span
              className="font-semibold cursor-pointer"
              onClick={() => setVisible(true)}
            >
              查看更多
            </span>
          </>
        ) : (
          <>{text}</>
        )}
      </div>
      <MyModal
        visible={visible}
        title={title}
        onCancel={() => setVisible(false)}
        maskStyle={{
          backgroundColor: 'rgba(0,0,0,0.8)',
        }}
        width={704}
        footer={null}
      >
        <div
          className="text-neutral-400 text-base"
          dangerouslySetInnerHTML={{
            __html: toHtml(text),
          }}
        ></div>
      </MyModal>
    </>
  )
}
